/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import paymentTypes, {
  paymentStatusValues
} from '../../../const-values/paymentTypes';
import productSettingsOptions from '../../../const-values/productSettingsOptions';
import StoreOrdersContext from '../../../contexts/store-orders-context/StoreOrdersContext';
import './OrderRecipt.scss';

const OrderRecipt = React.forwardRef((props, ref) => {
  const { selectedOrder: selectedRecipt } = useContext(StoreOrdersContext);
  const { t, i18n } = useTranslation();
  const sharedT = (key) => t(`orderReceipt.${key}`);
  //
  //
  //
  //
  const renderDiscountTitle = (p) => {
    if (p?.offerType) {
      return (
        <p
          style={{
            fontSize: 11,
            color: '#000'
          }}
          className="discount-p"
        >
          {t('discount')}
        </p>
      );
    }
    return null;
  };

  const renderDiscountValue = (p) => {
    if (p?.offerType && p?.offerPrice) {
      return <p className="discount-v">{p.offerPrice}</p>;
    }
    return null;
  };

  //
  //
  //
  //
  //
  const renderProductOptionTitle = (p) => {
    if (p?.optionType) {
      const foundOption =
        productSettingsOptions(t)?.length > 0 &&
        productSettingsOptions(t).find((obj) => obj.value == p?.optionType);
      if (foundOption) {
        return (
          <p
            style={{
              fontSize: 11,
              color: '#000'
            }}
            className="option-p"
          >
            {foundOption?.name}
          </p>
        );
      }
      return '---';
    }
  };
  const renderProductOptionValue = (p) => {
    if (p?.optionType && p.optionPrice) {
      return <p className="option-v">{p.optionPrice}</p>;
    }
  };
  //
  //
  //
  //
  //

  const renderProducts = () => {
    return (
      <div className="products-table-total-wrap">
        <table
          className="invoice-products-table"
          style={{
            fontFamily: `DroidKufi-Regular, Poppins-Regular !important`,
            width: 'calc(100% - 36px)',
            margin: '0 10px',
            padding: 0,
            textAlign: i18n.dir() === 'rtl' ? 'right' : 'left',
            borderCollapse: 'separate',
            borderCpacing: '4px 10px'
          }}
        >
          <thead>
            <tr className="invoice-products-head">
              <th
                style={{
                  minWidth: '118px',
                  padding: '2px',
                  fontSize: '12px',
                  fontWeight: 'normal',
                  color: '#000'
                }}
                className="invoice-table-cell product-name-cell"
              >
                {sharedT('productClass')}
              </th>
              <th
                style={{
                  padding: '2px',
                  fontSize: '13px',
                  fontWeight: 'normal',
                  color: '#000'
                }}
                className="invoice-table-cell product-quantity-cell"
              >
                {sharedT('quantity')}
              </th>
              <th
                style={{
                  padding: '2px',
                  fontSize: '13px',
                  fontWeight: 'normal',
                  color: '#000'
                }}
                className="invoice-table-cell product-price-cell"
              >
                {sharedT('price')}
              </th>
              <th
                style={{
                  padding: '2px',
                  fontSize: '13px',
                  fontWeight: 'normal',
                  color: '#000'
                }}
                className="invoice-table-cell product-price-cell"
              >
                {sharedT('productTotal')}
              </th>
            </tr>
          </thead>
          <tbody>
            {selectedRecipt?.products?.length > 0 &&
              selectedRecipt.products.map((p) => renderInoviceProduct(p))}
          </tbody>
        </table>

        <table
          className="prices-table"
          style={{
            width: 'calc(100% - 36px)',
            borderTop: '1px dashed #000',
            margin: 'auto',
            textAlign: i18n.dir() === 'rtl' ? 'right' : 'left',
            borderCollapse: 'separate',
            borderSpacing: '4px 8px',
            color: '#000'
          }}
        >
          <tbody>
            {selectedRecipt.productPrice > 0 && (
              <tr className="total-before-discount-wrap">
                <th
                  style={{
                    padding: '2px',
                    minWidth: '182px',
                    fontSize: '13px',
                    color: '#000'
                  }}
                  className="invoice-table-cell col-head"
                >
                  {sharedT('subTotal')} :{' '}
                </th>
                <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                <td
                  style={{ padding: '2px', color: '#000' }}
                  className="invoice-table-cell discount-value"
                >
                  {selectedRecipt.productPrice}
                </td>
              </tr>
            )}
            {selectedRecipt.discountPrice > 0 && (
              <tr className="total-before-discount-wrap">
                <th
                  style={{
                    padding: '2px 4px',
                    minWidth: '182px',
                    fontSize: '13px',
                    color: '#000'
                  }}
                  className="invoice-table-cell col-head"
                >
                  {sharedT('discountPrice')} :{' '}
                </th>
                <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                <td
                  style={{ padding: '2px', color: '#000' }}
                  className="invoice-table-cell discount-value"
                >
                  {selectedRecipt.discountPrice}
                </td>
              </tr>
            )}

            {selectedRecipt.taxPrice > 0 && (
              <tr className="total-before-discount-wrap">
                <th
                  style={{
                    padding: '2px',
                    minWidth: '182px',
                    fontSize: '13px',
                    color: '#000'
                  }}
                  className="invoice-table-cell col-head"
                >
                  {sharedT('tax')}
                  {' : '}
                </th>
                <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                <td
                  style={{ padding: '2px', color: '#000' }}
                  className="invoice-table-cell discount-value"
                >
                  {selectedRecipt.taxPrice}
                </td>
              </tr>
            )}
            {selectedRecipt.totalPrice > 0 && (
              <tr className="total-before-discount-wrap">
                <th
                  style={{
                    padding: '2px',
                    width: '182px',
                    fontSize: '13px',
                    color: '#000'
                  }}
                  className="invoice-table-cell col-head"
                >
                  {sharedT('grandTotal')}
                  {' : '}
                </th>
                <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                <td
                  style={{ padding: '2px' }}
                  className="invoice-table-cell discount-value"
                >
                  {selectedRecipt.totalPrice}
                </td>
              </tr>
            )}
            {selectedRecipt.returnPrice &&
              parseFloat(selectedRecipt.returnPrice) > 0 && (
                <tr className="total-before-discount-wrap">
                  <th
                    style={{
                      padding: '2px',
                      width: '182px',
                      fontSize: '13px',
                      color: '#000'
                    }}
                    className="invoice-table-cell col-head"
                  >
                    المبلغ المرتجع :{' '}
                  </th>
                  <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                  <td
                    style={{ padding: '2px' }}
                    className="invoice-table-cell discount-value"
                  >
                    {selectedRecipt.returnPrice}
                  </td>
                </tr>
              )}
            {selectedRecipt.totalPrice > 0 && (
              <tr className="total-before-discount-wrap">
                <th
                  style={{
                    padding: '2px',
                    width: '182px',
                    fontSize: '13px',
                    color: '#000'
                  }}
                  className="invoice-table-cell col-head"
                >
                  {sharedT('paymentMethod')}
                  {' : '}
                </th>
                <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                <td
                  style={{ padding: '2px', color: '#000' }}
                  className="invoice-table-cell discount-value"
                >
                  {paymentTypes(t)?.find(
                    (obj) => obj.value == selectedRecipt?.paymentType
                  )?.name ?? ''}
                  {selectedRecipt?.paymentStatus ==
                    paymentStatusValues.not_paid && (
                    <p style={{ fontSize: 11, color: 'red' }}>
                      ( {t('not_paid')} )
                    </p>
                  )}
                </td>
              </tr>
            )}

            {/* {selectedRecipt.returnTax &&
              parseFloat(selectedRecipt.returnTax) > 0 && (
                <tr className="total-before-discount-wrap">
                  <th
                    style={{
                      padding: '2px',
                      width: '182px',
                      fontSize: '13px',
                      color: '#000'
                    }}
                    className="invoice-table-cell col-head"
                  >
                    الضريبة المرتجعة :{' '}
                  </th>
                  <td className="style={{padding: '2px', , color: '#000', width: '70px'}} fake-td invoice-table-cell"></td>
                  <td
                    style={{ padding: '2px' }}
                    className="invoice-table-cell discount-value"
                  >
                    {selectedRecipt.returnTax}
                  </td>
                </tr>
              )} */}
          </tbody>
        </table>
        {/* {invoiceTotalPriceAfterTax > 0 && (
          <div className="grand-total-invoice-price">
            <span>المجموع الكلى</span>
            <span className="bold-font">{invoiceTotalPriceAfterTax}</span>
          </div>
        )} */}

        {/* <div className="qr-code-img-wrap">
          <img className="qrcode-img" src={qrCodeImg} alt="qrcode" />
        </div> */}

        <div
          style={{
            textAlign: 'center',
            padding: '0 8px 10px 8px'
          }}
        >
          {/* {systemSettings?.slogan ? systemSettings.slogan : ''} */}
          {selectedRecipt?.setting?.slogan ? selectedRecipt.setting.slogan : ''}
        </div>
      </div>
    );
  };

  const renderInoviceProduct = (p) => {
    return (
      <tr key={p.id} className="invoice-product-li">
        <td
          style={{
            verticalAlign: 'top',
            padding: '2px',
            fontSize: '13px',
            color: '#000'
          }}
          className="invoice-table-cell product-name-cell"
        >
          {p?.product?.name ? p.product.name : '----'}
          {renderDiscountTitle(p)}
          {renderProductOptionTitle(p)}
        </td>
        <td
          style={{ verticalAlign: 'top', padding: '2px', color: '#000' }}
          className="invoice-table-cell product-quantity-cell"
        >
          {p.quantity ? p.quantity : '----'}
        </td>
        <td
          style={{ verticalAlign: 'top', padding: '2px', color: '#000' }}
          className="invoice-table-cell product-price-cell"
        >
          {p?.servicePrice ? parseFloat(p.servicePrice) : '----'}
          {renderDiscountValue(p)}
          {renderProductOptionValue(p)}
        </td>
        <td
          style={{ verticalAlign: 'top', padding: '2px', color: '#000' }}
          className="invoice-table-cell product-price-cell"
        >
          {p?.totalPrice ? parseFloat(p.totalPrice) : '----'}
        </td>
      </tr>
    );
  };

  return (
    <div
      ref={ref}
      className="print-whole-receipt-wrap-store"
      style={{
        direction: i18n.dir()
      }}
    >
      <div
        className="receipt-wrap"
        style={{
          fontFamily: `DroidKufi-Regular, Poppins-Regular !important`,
          height: 'max-content',
          color: '#000',
          position: 'relative'
        }}
      >
        <img
          style={{
            position: 'absolute',
            left: 0,
            height: 44
          }}
          className="naomi-logo"
          src="/assets/imgs/logo/logo.png"
          alt="naomi"
        />
        <div
          className="store-logo-name-wrap"
          style={{
            display: 'grid',
            placeItems: 'center',
            minWidth: '92px',
            minHeight: '92px'
          }}
        >
          {selectedRecipt?.store?.logo ? (
            <img
              className="system-logo"
              src={selectedRecipt?.store?.logo}
              alt="logo"
              style={{
                // width: '92px',
                height: '92px'
              }}
            />
          ) : null}

          <div className="store-name">
            {selectedRecipt?.store?.name || '---'}
          </div>
        </div>

        <div className="invoice-content">
          <div className="invoice-number">
            <p className="number-span" style={{ color: '#000' }}>
              {sharedT('receiptNumber')} :{' '}
              {selectedRecipt?.id ? '00' + selectedRecipt.id : ''}
            </p>
          </div>
          <div
            className="system-info"
            style={{
              margin: '4px 10px',
              paddingBottom: '12px',
              marginBottom: '0',
              borderBottom: '1px dashed #000',
              gap: '12px 4px',
              color: '#000',
              fontSize: '13px'
            }}
          >
            {selectedRecipt?.store?.address && (
              <p
                style={{
                  textAlign: 'center',
                  marginTop: 8
                }}
              >
                {selectedRecipt.store.address}
              </p>
            )}
            {selectedRecipt?.created_at && (
              <p
                style={{
                  textAlign: 'center',
                  marginTop: 8
                }}
              >
                {selectedRecipt.created_at}
              </p>
            )}
          </div>

          {renderProducts()}
        </div>
      </div>
    </div>
  );
});

export default OrderRecipt;
